// src/app/pages/terms-page/terms-page.component.ts
import { Component } from '@angular/core';

@Component({
  selector: 'app-terms-page',
  standalone: true,
  imports: [],
  templateUrl: './terms-page.component.html',
  styleUrls: ['./terms-page.component.scss'],
})
export class TermsPageComponent {}
